import { IDataSelect } from "@app/interfaces/idata-select"

export const PROFILE_UPDATE_FILTER: Array<IDataSelect> = [
    { id: "1w", label: "1 semana" },
    { id: "2w", label: "2 semanas" },
    { id: "3w", label: "3 semanas" },
    { id: "4w", label: "1 mes" },
    { id: "8w", label: "2 meses" },
    { id: "12w", label: "3 meses" },
    { id: "52w", label: "1 año" },
    { id: "52w+", label: "más de 1 año" },
]